import { inputs } from '@ecosystem/newron-design-system';
import React, { useCallback, useEffect } from 'react';

import { MAX_NAME_LENGTH } from '../../constants';

const { TextInput } = inputs;

export interface AddInsightNameProps {
  name: string;
  setName: (name: string) => void;
  setValid: (valid: boolean) => void;
}

export const AddInsightName: React.FC<AddInsightNameProps> = ({ name, setName, setValid }) => {
  const handleSetName = useCallback(
    (name: string) => {
      setName(name);
    },
    [setName]
  );

  useEffect(() => {
    setValid(!!name?.length);
  }, [name?.length, setValid]);

  return (
    <TextInput
      name="insightName"
      label="Title of insight"
      onChange={handleSetName}
      value={name ?? ''}
      testId="insightName"
      placeholder="Give your insight a name"
      maxLength={MAX_NAME_LENGTH}
      autoComplete="off"
    />
  );
};
